<template>
<div class="chapter">
<div class="inner_page">
<p class="part-title"><span>SACRAMENTO, CALIFORNIA</span></p>
<p class="part-suptitle"><span>Monday, June 8, 1992</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?373b69be